import { z } from 'zod';

/** Contratos de Categorias (M2). Hierarquia de 1 nível; filho herda a cor do pai. */

export const categoryTypeSchema = z.enum(['income', 'expense']);
export type CategoryType = z.infer<typeof categoryTypeSchema>;

const hexColorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Cor deve ser um hex #RRGGBB.');

/** Nó já com a cor efetiva resolvida (filho recebe a cor do pai). */
export const categorySchema = z.object({
  id: z.string(),
  name: z.string(),
  type: categoryTypeSchema,
  icon: z.string(),
  /** Cor efetiva (nunca nula na resposta — o service resolve a herança). */
  color: hexColorSchema,
  parentId: z.string().nullable(),
  isSystem: z.boolean(),
  systemKey: z.string().nullable(),
  archived: z.boolean(),
  sortOrder: z.number().int(),
});
export type Category = z.infer<typeof categorySchema>;

/** Categoria-pai com seus filhos aninhados (árvore de 1 nível). */
export type CategoryNode = Category & { children: Category[] };
export const categoryNodeSchema: z.ZodType<CategoryNode> = categorySchema.extend({
  children: z.lazy(() => z.array(categorySchema)),
});

export const categoriesResponseSchema = z.object({
  categories: z.array(categoryNodeSchema),
});
export type CategoriesResponse = z.infer<typeof categoriesResponseSchema>;

export const createCategoryBodySchema = z.object({
  name: z.string().trim().min(1, 'Informe o nome.').max(40),
  type: categoryTypeSchema,
  icon: z.string().min(1).max(40),
  /** Obrigatória no pai; se filho, pode omitir para herdar. */
  color: hexColorSchema.optional(),
  /** Preenchido cria subcategoria (o tipo é herdado do pai). */
  parentId: z.string().optional(),
});
export type CreateCategoryBody = z.infer<typeof createCategoryBodySchema>;

export const updateCategoryBodySchema = z.object({
  name: z.string().trim().min(1).max(40).optional(),
  icon: z.string().min(1).max(40).optional(),
  color: hexColorSchema.optional(),
});
export type UpdateCategoryBody = z.infer<typeof updateCategoryBodySchema>;

/** Item de "categorias mais usadas" para os chips do modal de lançamento (M3). */
export const frequentCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  icon: z.string(),
  color: hexColorSchema,
});
export type FrequentCategory = z.infer<typeof frequentCategorySchema>;
